import React from 'react';

export const CommonChallenges: React.FC = () => {
  const challenges = [
    {
      icon: 'ri-tools-line',
      title: 'Deferred Maintenance',
      problem: 'Years of delayed repairs and upgrades have accumulated, creating a long list of needed improvements.',
      solution: 'We buy garden apartments as-is, regardless of condition. You don\'t need to fix roofs, update units, repair parking lots, or address any maintenance issues before selling.'
    },
    {
      icon: 'ri-landscape-line',
      title: 'Landscaping Costs',
      problem: 'Maintaining extensive grounds, trees, irrigation systems, and outdoor amenities requires ongoing investment and management.',
      solution: 'We understand that landscaping is a significant operating expense for garden apartments. Our valuations account for these costs, and you can sell without bringing grounds up to perfect condition.'
    },
    {
      icon: 'ri-building-4-line',
      title: 'Aging Building Systems',
      problem: 'HVAC systems, plumbing, electrical, and roofing in older garden apartments often need replacement or major repairs.',
      solution: 'We specialize in properties with aging infrastructure. Our team has experience renovating and upgrading building systems, so we can purchase properties that other buyers might avoid.'
    },
    {
      icon: 'ri-group-line',
      title: 'Tenant Management',
      problem: 'Managing tenants across multiple buildings, handling maintenance requests, and dealing with turnover can be overwhelming.',
      solution: 'Sell with tenants in place. We handle all tenant relationships after closing, and you can exit property management responsibilities immediately.'
    },
    {
      icon: 'ri-funds-line',
      title: 'Capital Expenditure Needs',
      problem: 'Major capital improvements like roof replacements, parking lot resurfacing, or building envelope repairs require substantial investment.',
      solution: 'We factor capital needs into our offers and handle all future improvements ourselves. You avoid the stress and expense of major capital projects.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Market Changes',
      problem: 'Suburban markets evolve, and garden apartments may face increased competition from newer properties or changing demographics.',
      solution: 'We buy in all market conditions and locations. Whether your property faces strong competition or is in a transitioning neighborhood, we can make an offer.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Common Garden Apartment Challenges We Solve
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Garden apartment ownership comes with unique challenges. We understand these issues and provide solutions that make selling easy.
          </p>
        </div>

        <div className="mb-16">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/6759a43a95b9899eaf3f8868550b1a3f.jpg"
              alt="Garden Apartment Maintenance Challenges"
              className="w-full h-[450px] object-cover object-top"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {challenges.map((challenge, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-gray-50 rounded-xl border border-gray-200 p-8 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start mb-6">
                <div className="w-14 h-14 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className={`${challenge.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mt-2">
                  {challenge.title}
                </h3>
              </div>
              
              <div className="mb-6">
                <h4 className="text-sm font-bold text-red-600 uppercase tracking-wide mb-2">
                  The Challenge
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  {challenge.problem}
                </p>
              </div>
              
              <div>
                <h4 className="text-sm font-bold text-green-600 uppercase tracking-wide mb-2">
                  Our Solution
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  {challenge.solution}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};